export interface AuthError {
  code: string;
  title: string;
  message: string;
}

export type AuthErrorCode = "C001" | "C002" | "C003" | "C004" | "C005" | "C006";

export const AUTH_ERRORS: Record<AuthErrorCode, AuthError> = {
  C001: {
    code: "C001",
    title: "Divergência entre login do Conectado e login do AD!",
    message:
      "Identificamos uma diferença entre seu login no Conectado e o login da rede Claro. Solicite a atualização do seu cadastro à sua liderança. C001",
  },
  C002: {
    code: "C002",
    title: "Divergência entre CPF do Conectado e CPF do AD!",
    message:
      "Identificamos uma diferença entre seus dados no Conectado e da rede Claro. Solicite a atualização do seu cadastro à sua liderança. C002",
  },
  C003: {
    code: "C003",
    title: "Usuário inativo no Conectado!",
    message:
      "Seu acesso ao Conectado está inativo. Solicite reativação junto à sua liderança. C003",
  },
  C004: {
    code: "C004",
    title: "Usuário sem cadastro no Conectado!",
    message:
      "Parece que você ainda não possui acesso ao Conectado. Solicite cadastro à sua liderança. C004",
  },
  C005: {
    code: "C005",
    title: "Atenção!",
    message:
      "Ocorreu um problema com o seu acesso. Entre em contato com a sua liderança. C005",
  },
  C006: {
    code: "C006",
    title: "Acesso não autorizado!",
    message:
      "Seu perfil não possui permissão para acessar o aplicativo Conectado. Solicite a liberação à sua liderança. C006",
  },
};

const isAuthErrorCode = (code: unknown): code is AuthErrorCode =>
  typeof code === "string" &&
  Object.prototype.hasOwnProperty.call(AUTH_ERRORS, code);

export const getAuthError = (code?: unknown): AuthError =>
  isAuthErrorCode(code) ? AUTH_ERRORS[code] : AUTH_ERRORS.C005;

export const formatAuthError = ({ title, message }: AuthError) =>
  `${title}\n${message}`;
